import type { MailboxInfo } from 'owa-client-types';
import { getMailboxInfo } from '../selectors/mailRowDataPropertyGetter';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';
import type TableView from '../store/schema/TableView';
import { isSameMailboxInfo } from 'owa-account-source-list-store';

export function getRowKeyMailboxInfoIfUnifiedInbox(
    mailboxInfo: MailboxInfo,
    tableView: TableView,
    rowkey: string
): MailboxInfo {
    if (isUnifiedInboxMailboxInfo(mailboxInfo)) {
        const rowKeyMailboxInfo = getMailboxInfo(rowkey, tableView);
        if (rowKeyMailboxInfo) {
            mailboxInfo = rowKeyMailboxInfo;
        }
    }
    return mailboxInfo;
}

// Tries to get the row keys' mailbox info if unified inbox or returns the default mailbox info
// If row keys are from different mailboxes, it returns undefined
export function tryGetRowKeysSameMailboxInfoIfUnifiedInboxOrDefault(
    defaultMailboxInfo: MailboxInfo,
    tableView: TableView,
    rowKeys: string[]
): MailboxInfo | undefined {
    if (isUnifiedInboxMailboxInfo(defaultMailboxInfo)) {
        const mailboxInfos = rowKeys.map(rowKey => getMailboxInfo(rowKey, tableView));

        // Check if all mailboxInfos are the same
        // Go through the mailboxInfos array and compare previous and current mailboxInfo
        for (let i = 1; i < mailboxInfos.length; i++) {
            if (!isSameMailboxInfo(mailboxInfos[i - 1], mailboxInfos[i])) {
                return undefined;
            }
        }
        // If all mailboxInfos are the same, return the first one
        return mailboxInfos[0];
    }

    return defaultMailboxInfo;
}
